import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsTimeslotKind from 'graphql/fields/FieldsTimeslotKind'
import FieldsCreditBundle from 'graphql/fields/FieldsCreditBundle';

const fields = {
	'guid': 'String',
	'name': 'String!',
	'credits_amount': 'Int!',
	'price': 'Float!',
	'timeslot_kind_guid': 'String',
	'status': 'String',
};

export default gql(`
	mutation credit_bundle( ${ HelperGraphql.createFields( fields ) } ) {
	    credit_bundle( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsCreditBundle}
	    }
	}
`);

